'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { useJejuDonationValidation } from '@/app/donation/_hooks/useJejuDonationValidation';
import { DONATION_ROUTES } from '@/constants';
import { CertificateCard } from './CertificateCard';

// 연속 기부 년차 계산: 가장 최근 기부년도부터 연속된 횟수만 계산
// 예: 25년 기부 → 1년차, 25+26년 연속 → 2년차, 25년+27년(26년 X) → 1년차
const calculateConsecutiveDonationYears = (donationYears: number[]) => {
  if (donationYears.length === 0) return 0;
  const uniqueYears = [...new Set(donationYears)].sort((a, b) => b - a);
  const startYear = uniqueYears[0];
  const breakIndex = uniqueYears.findIndex((year, index) => year !== startYear - index);
  return breakIndex === -1 ? uniqueYears.length : breakIndex;
};
export const JejuCertificateContent = t0 => {
  const $ = _c(20);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = {
      onFailed: () => {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isDonatedToJeju
  } = useJejuDonationValidation(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = AuthQueryOptions["get:/wello/v2/auth/home-donation/certificate"]();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isDonatedToJeju) {
    t3 = {
      ...t2,
      select: _temp,
      enabled: isDonatedToJeju
    };
    $[3] = isDonatedToJeju;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: certificate
  } = useQuery(t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = AuthQueryOptions["get:/wello/v2/auth/home-donation/history"]({
      query: {
        page: 1,
        size: 100
      }
    });
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isDonatedToJeju) {
    t5 = {
      ...t4,
      select: _temp2,
      enabled: isDonatedToJeju
    };
    $[6] = isDonatedToJeju;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: donationHistory
  } = useQuery(t5);
  let t6;
  bb0: {
    if (!donationHistory) {
      t6 = null;
      break bb0;
    }
    let t7;
    if ($[8] !== donationHistory) {
      const completedDonationYears = donationHistory.filter(_temp3).map(_temp4);
      t7 = calculateConsecutiveDonationYears(completedDonationYears);
      $[8] = donationHistory;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    const consecutiveYears = t7;
    t6 = consecutiveYears > 0 ? consecutiveYears : null;
  }
  const donationYear = t6;
  const t7 = certificate?.name;
  const t8 = certificate?.issuedDate;
  const t9 = certificate?.certificateIssueEndDate;
  let t10;
  if ($[10] !== donationYear || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <CertificateCard year={donationYear} name={t7} issuedAt={t8} expiredAt={t9} />;
    $[10] = donationYear;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== onClose) {
    t11 = <CustomLink href={DONATION_ROUTES.MY_JEJU_BENEFIT.pathname} aria-label={"\uD0D0\uB098\uB294 \uC81C\uC8FC\uD328\uC2A4 \uD61C\uD0DD \uC548\uB0B4 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} onClick={onClose} className="mt-32 flex h-60 w-full items-center justify-center rounded-small bg-Gray-black font-700 text-Gray-white transition-colors duration-150 ease-in-out typo-body3 hover:bg-Gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-Gray-black active:bg-Gray-800">혜택보기</CustomLink>;
    $[15] = onClose;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <article className="flex flex-col items-center pt-32 mobile-tablet:pt-12">{t10}{t11}</article>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
function _temp(data) {
  return data.context;
}
function _temp2(data_0) {
  return data_0.context?.contents;
}
function _temp3(donation) {
  return donation.donationStatus === "COMPLETED";
}
function _temp4(donation_0) {
  return dayjs(donation_0.paidAt).year();
}